import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { UWRequirementActionEvent, UWRequirementTableData } from '@Underwriting/models';

import { UWRequirementTableActions, UWRequirementTableProps } from '../uw-requirements-expand-table';
import { NgIf } from '@angular/common';
import { MatMenuItem } from '@angular/material/menu';
import { MatDivider } from '@angular/material/list';
import { SharedModule } from '@Shared/shared.module';
import { UWRequirementsActionsItemDocumentComponent } from '../uw-requirements-actions-item-documents';
import { UWRequirementsActionsItemAgentCommunicationsComponent } from '../uw-requirements-actions-item-agent-communications/uw-requirements-actions-item-agent-communications.component';


@Component({
    selector: 'uw-requirements-actions-ordered',
    templateUrl: './uw-requirements-actions-ordered.component.html',
    styleUrls: ['./uw-requirements-actions-ordered.component.scss'],
    imports: [
        MatMenuItem, MatDivider, SharedModule,
        forwardRef(() => UWRequirementsActionsItemDocumentComponent),
        forwardRef(() => UWRequirementsActionsItemAgentCommunicationsComponent)]
})
export default class UWRequirementsActionsOrderedComponent {
    @Input() caseRequirement: UWRequirementTableData;
    @Input() props: UWRequirementTableProps;
    @Output() onMenuAction = new EventEmitter<UWRequirementActionEvent>();

    public get UWRequirementTableActions() {
        return UWRequirementTableActions;
    }

    handleMenuAction(columnAction: UWRequirementTableActions, caseRequirement: UWRequirementTableData) {
        const actionEvent: UWRequirementActionEvent = {
            action: columnAction,
            data: caseRequirement
        };
        this.onMenuAction.emit(actionEvent);
    }

    handleMenuActionEvent(event: UWRequirementActionEvent) {
        this.onMenuAction.emit(event);
    }    
}
